import {
    PM_SESSION_START,
    PM_WINDOW_MINIMIZE,
    PM_WINDOW_MINIMIZE_ALL,
    PM_WINDOW_MAXIMIZE,
    PM_SESSION_HIDE,
} from '../constants/pm';

export function startPmSession(user) {
    return {
        type: PM_SESSION_START,
        conversation_uid: user.uid,
        user
    }
}

export function minimizePmWindow(user) {
    return {
        type: PM_WINDOW_MINIMIZE,
        conversation_uid: user.uid,
        user
    }
}

export function minimizeAllPmWindows() {
    return {
        type: PM_WINDOW_MINIMIZE_ALL
    }
}

export function maximizePmWindow(user) {
    return {
        type: PM_WINDOW_MAXIMIZE,
        conversation_uid: user.uid,
        user
    }
}

export function hidePmWindow(user) {
    return {
        type: PM_SESSION_HIDE,
        conversation_uid: user.uid,
        uid: user.uid,
        user
    }
}


// WEBPACK FOOTER //
// ./src/actions/pm.js